<div class="field flex flex-column">
  <label class="mb-2" *ngIf="options.label">
    {{ options.label | translate }}
  </label>
  <div class="flex">
    <p-colorPicker
      class="mr-2"
      (onChange)="onChangeColor($event)"
      [ngModelOptions]="{ standalone: true }"
      [(ngModel)]="color"
    ></p-colorPicker>
    <input
      [type]="'text'"
      class="w-full"
      [placeholder]="(options.placeholder | translate) ?? ''"
      [formControlName]="options.formControlName"
      (input)="onChange($event)"
      pInputText
    />
  </div>
  <app-field-errors [errors]="errors"></app-field-errors>
</div>
